<template>
  <div class="sp-template">
    <!-- 从保险页面复制 insuraanceorder.vue -->
    <div class="h-title">提成费用异常</div>
    <el-card class="box-card">
      <div slot="header" class="clearfix">

        <el-form :inline="true" :model="conditions" class="header-search__form" size="small" label-width="90px">

          <el-row>
            <el-form-item label="订单号">
              <el-input type="textarea" v-model="conditions.orderIdText" placeholder="多个订单号用回车分割"></el-input>
            </el-form-item>

           

          </el-row>

          <el-row>
            <el-form-item>
              <div class="search-form__buttons">
                <el-button type="primary" size="small" @click="searchTask">搜 索</el-button>
              </div>
            </el-form-item>
          </el-row>


        </el-form>
      </div>
      <div class="table-operate__buttons">
        <el-tabs >
          <el-tab-pane label="异常列表" name="0"></el-tab-pane>
        </el-tabs>

        <div class="button-groups">
          <el-button size="small" @click="batchRecalculate()"  v-if="in_configs(42301)" >批量重新计算提成</el-button>


        </div>
      </div>
      <el-table :data="tableData" stripe border @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55"></el-table-column>

        <!-- <el-table-column prop="id" label="id"></el-table-column> -->
        <el-table-column prop="orderId" label="订单号"></el-table-column>

        <el-table-column label="客户">
          <template slot-scope="scope">
            {{customerMaps[scope.row.orgOwner]}}
          </template>
        </el-table-column>
        <el-table-column label="渠道">
          <template slot-scope="scope">
            {{channelsMaps[scope.row.productId]}}
          </template>
        </el-table-column>

        <el-table-column prop="remarks" label="异常原因"></el-table-column>


        <el-table-column prop="createdAt" label="创建时间"></el-table-column>

        <el-table-column label="操作" >
          <template slot-scope="scope">
            <el-button type="text" size="mini" @click="recalculate(scope.row)"  v-if="in_configs(42301)" > 重新计算提成</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page="currentPage" :page-sizes="[10, 50, 100, 500, 2000, 10000]" :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper" :total="total">
      </el-pagination>
    </el-card>


  </div>




</template>

<script>
  import { mapState, mapMutations } from "vuex";
  export default {
    data() {
      return {
        customers: [],
        customerMaps: {},
        channels: [],
        channelsMaps: {},
        salesmans: [],
        salesmansMaps: {},

        categorys: [],
        categoryMap: {},
        kinds: [],
        sumbitForm: {
          categoryId: "",
          kindId: "",
          supplierId: ""
        },
        suppliers: [],
        supplierMap: {},
        isPass: "1",
        dialogCheckVisible: false,
        tableData: [],
        batchOrderIds: [],
        multipleSelection: [],
        batchInsuranceOrderIdsShow: false,
        conditions: {
          orderIdText: '',
          startDate: "",
          endDate: "",
          salesman: "",
          orgOwner: "",
          productId: "",
          status: -1
        },

        dialogEditVisible: false,
        editData: {},
        total: 0,
        currentPage: 1,
        pageSize: 10
      };
    },
    components: {},
    created() {
      setTimeout(() => {

        let _this = this;
        let urlArray = [
          this.findAllCustomerName(),
          this.findAllChannle()
        ]; // unknown # of urls (1 or more)

        this.$axios.all(urlArray).then(
          this.$axios.spread(function (customerData, channelData) {
            _this.initCustomerData(customerData);
            _this.initChannelData(channelData);

            _this.loadRoleList("业务员");

            _this.query();
          })
        );



      }, 1000);
    },
    methods: {
      ...mapMutations([
        "setManualTrackingNumbers",
        "setOrderListTable",
        "setOrderListConditions",
        "setOrderListSearchMore"
      ]),
      formatRefNumber(refNumber) {
        let arr = refNumber;
        arr.forEach((item, index) => {
          if (item === " " || item === ",") {
            arr.splice(index, 1);
          }
        });
        return arr;
      },
      //查询渠道
      findAllChannle() {
        return this.$request1.get(
          '/system/channel/all',
          {
            withCredentials: true
          }
        );
      },
      //查询客户
      findAllCustomerName() {
        return this.$request1.get(
          '/customerAll',
          {
            withCredentials: true
          }
        );
      },
      initChannelData(data) {
        let _this = this;
        _this.channels = data.data;
        if (_this.channels.length > 0) {
          _this.channels.forEach(c => {
            _this.channelsMaps[c.id] = c.name;
          });
        }
      },
      initCustomerData(data) {
        let _this = this;
        if (data.data.success) {
          _this.customers = data.data.data;
          if (_this.customers.length > 0) {
            _this.customers.forEach(c => {
              _this.customerMaps[c.id] = c.name;
            });
          }
        }
      },
      //查询业务员和客服
      loadRoleList(role) {
        let _this = this;
        _this.$request1
          .get(
            '/staffrole',
            {
              params: {
                role: role
              }
            },
            {
              withCredentials: true
            }
          )
          .then(function (res) {
            if (res.data.success) {
              if (role == "业务员") {
                _this.salesmans = res.data.data;

                _this.salesmans.forEach(a => {
                  _this.salesmansMaps[a.id] = a.name
                })

              } else if (role == "客服") {
                _this.customerServiceStaffs = res.data.data;
              }
            } else {
              _this.salesmans = [];
              _this.customerServiceStaffs = [];
              _this.$message.error(res.data.message);
            }
          })
          .catch(function (error) {
            console.log(error);
          });
      },
      searchTask() {
        this.currentPage = 1;
        this.query();
      },
      query() {
        let _this = this;

        this.conditions.orderIds = [];

        if (this.conditions.orderIdText) {
          this.conditions.orderIds = this.conditions.orderIdText.split(/\n+/gim).map(a => a.trim()).filter(a => a);
        }

        this.conditions.currentPage = this.currentPage;
        this.conditions.pageSize = this.pageSize;

        //  this.tableData = [{"batchId": "11111", "orderId": "222222222"}]
        //  return;

        this.$request1({
          method: 'post',
          url: '/commission/query',
          data: _this.conditions,
          withCredentials: true,
          header: {
            'Content-Type': 'application/json'
          }
        })
          .then(response => {
            if (response.data.success) {
              this.tableData = response.data.data.list;
              this.total = response.data.total;
            } else {
              this.$message.error(response.data.message);
            }
          })
          .catch(error => {
            console.log(error);
          });
      },
      batchRecalculate(){
        let _this = this
        if (this.multipleSelection.length == 0) {
          this.$message.error(`请勾选订单`);
          return;
        }
        let orderIds = this.multipleSelection.map(a => a.orderId)
          let form = {
            orderIds: orderIds
          }

          this.$request1.post(
              '/commission/recalculate',
              form,
              {
                withCredentials: true,
                headers: {
                  "content-type": "application/json"
                }
              }
            ).then(function (response) {
              if (response.data.success) {
                _this.$message.success("提交成功");
                _this.dialogEditVisible = false
                _this.query();

              } else {
                _this.$message.error(response.data.message);
              }
            });

      },
      recalculate(val){
        let _this = this

        this.$confirm(`确定要重新计算该订单${val.orderId}`, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {

          let orderIds = this.multipleSelection.map(a => a.orderId)
          let form = {
            orderIds: [val.orderId]
          }

          this.$request1.post(
              '/commission/recalculate',
              form,
              {
                withCredentials: true,
                headers: {
                  "content-type": "application/json"
                }
              }
            ).then(function (response) {
              if (response.data.success) {
                _this.$message.success("提交成功");
                _this.dialogEditVisible = false
                _this.query();

              } else {
                _this.$message.error(response.data.message);
              }
            });


        }).catch(() => { });
      },
     // 审核提交
      checkSubmit() {
        let _this = this;
        let ids = this.multipleSelection.map(a => a.id);

        // console.log(ids);
        // return;
        this.$request1
          .post(
            '/insurance/audit',
            {
              ids: ids,
              status: _this.isPass

            },
            {
              withCredentials: true,
              headers: {
                "content-type": "application/json"
              }
            }
          )
          .then(function (response) {
            if (response.data.success) {
              _this.$message.success("提交成功");
              _this.dialogCheckVisible = false
              _this.query();

            } else {
              _this.$message.error(response.data.message);
            }
          });

      },
      popEdit(row) {
        this.dialogEditVisible = true;
        this.editData = row;

      },
      editSubmit() {
        let _this = this;

        this.$request1
          .post(
            '/commission/edit',
            _this.editData,
            {
              withCredentials: true,
              headers: {
                "content-type": "application/json"
              }
            }
          )
          .then(function (response) {
            if (response.data.success) {
              _this.$message.success("提交成功");
              _this.dialogEditVisible = false
              _this.query();

            } else {
              _this.$message.error(response.data.message);
            }
          });

      },
      exportAll() {
        let _this = this;
        if (this.multipleSelection.length == 0) {
          this.$message.error('请勾选要导出的订单');
          return;
        }

        // console.log(orderIds, batchIds);
        // return;

        var url = tmsSpringUrl + '/insurance/query';

        var form = document.createElement("form");
        form.method = "post";
        form.action = url;
        form.target = "_blank";
        document.body.appendChild(form);

        this.multipleSelection.forEach(a => {
          var input = document.createElement("input");
          input.type = "hidden";
          input.name = "ids[]";
          input.value = a.id;
          form.appendChild(input);
        });

        let d = { status: 2, export: 1 }
        Object.keys(d).forEach(key => {
          var input1 = document.createElement("input");
          input1.type = "hidden";
          input1.name = key;
          input1.value = d[key];
          form.appendChild(input1);
        })

        var input2 = document.createElement("input");
      input2.type = "hidden";
      input2.name = "token";
      input2.value = this.$getToken()
      form.appendChild(input2);

        form.submit();

      },
      //多选按钮
      handleSelectionChange(val) {
        console.log(">>>>>>val=", val);
        this.multipleSelection = val;
      },
      //分页
      handleSizeChange(val) {
        this.currentPage = 1;
        this.pageSize = val;
        this.query();
      },
      handleCurrentChange(val) {
        this.currentPage = val;
        this.query();
      },
      dateFormat(date, fmt) {
        var o = {
          "M+": date.getMonth() + 1, //月份
          "d+": date.getDate(), //日
          "h+": date.getHours() % 12 == 0 ? 12 : date.getHours() % 12, //小时
          "H+": date.getHours(), //小时
          "m+": date.getMinutes(), //分
          "s+": date.getSeconds(), //秒
          "q+": Math.floor((date.getMonth() + 3) / 3), //季度
          S: date.getMilliseconds() //毫秒
        };
        var week = {
          "0": "/u65e5",
          "1": "/u4e00",
          "2": "/u4e8c",
          "3": "/u4e09",
          "4": "/u56db",
          "5": "/u4e94",
          "6": "/u516d"
        };
        if (/(y+)/.test(fmt)) {
          fmt = fmt.replace(
            RegExp.$1,
            (date.getFullYear() + "").substr(4 - RegExp.$1.length)
          );
        }
        if (/(E+)/.test(fmt)) {
          fmt = fmt.replace(
            RegExp.$1,
            (RegExp.$1.length > 1
              ? RegExp.$1.length > 2
                ? "/u661f/u671f"
                : "/u5468"
              : "") + week[date.getDay() + ""]
          );
        }
        for (var k in o) {
          if (new RegExp("(" + k + ")").test(fmt)) {
            fmt = fmt.replace(
              RegExp.$1,
              RegExp.$1.length == 1
                ? o[k]
                : ("00" + o[k]).substr(("" + o[k]).length)
            );
          }
        }
        return fmt;
      }
    }
  };
</script>

<style>
  .el-message-box__message p {
    margin: 0;
    line-height: 24px;
    white-space: pre-wrap !important;
  }
</style>


// WEBPACK FOOTER //
// src/views/orderOperation/commission_exception.vue